import { ReactNode } from "react";

import { DefaultCommunityImage } from "~/modules/Common/Image/components/DefaultCommunityImage/DefaultCommunityImage";
import { DaoInfoType } from "~/modules/Router/Auth/types";
import { toBackgroundImages } from "~/utils/converter";

type Props = {
  children: ReactNode;
  className?: string;
  dao: Pick<DaoInfoType, "inviteBackgroundImageUrl" | "categoryId">;
};
export const CommunityInviteBackground = ({
  children,
  className,
  dao,
}: Props) => {
  return (
    <div
      className={`${className} flex-center relative h-screen w-full flex-col bg-ciety-dk-90 bg-cover bg-center bg-no-repeat`}
      style={{
        backgroundImage: dao.inviteBackgroundImageUrl
          ? `url(${dao.inviteBackgroundImageUrl})`
          : undefined,
      }}
    >
      {!dao.inviteBackgroundImageUrl && (
        <DefaultCommunityImage
          type={toBackgroundImages(dao.categoryId ?? "0")}
          className={"absolute left-0 top-0 h-full w-full !bg-cover !bg-center"}
        />
      )}
      {children}
    </div>
  );
};
